import React from 'react';
import * as GlobalVariables from '../config/GlobalVariableContext';
import { ButtonSolid, ScreenContainer, withTheme } from '@draftbit/ui';
import { StyleSheet, Text, TextInput, View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

const PracticenoticingSLTScreen = props => {
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();

  const { theme } = props;
  const { navigation } = props;

  const [textAreaValue, setTextAreaValue] = React.useState('');
  const [textAreaValue2, setTextAreaValue2] = React.useState('');
  const [textInputValue, setTextInputValue] = React.useState('');
  const [textInputValue2, setTextInputValue2] = React.useState('');
  const [textInputValue3, setTextInputValue3] = React.useState('');
  const [textInputValue4, setTextInputValue4] = React.useState('');
  const [textInputValue5, setTextInputValue5] = React.useState('');

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      hasTopSafeArea={true}
    >
      <View>
        <Text style={[styles.Textc3594145, { color: theme.colors.strong }]}>
          {'What cues did you notice?'}
        </Text>
      </View>

      <KeyboardAwareScrollView
        contentContainerStyle={styles.KeyboardAwareScrollViewc82de0d5Content}
        showsVerticalScrollIndicator={true}
        keyboardShouldPersistTaps={'never'}
      >
        {/* Situation */}
        <Text style={[styles.Text8acc43bb, { color: theme.colors.strong }]}>
          {'Situation'}
        </Text>
        {/* Situation text area */}
        <TextInput
          onChangeText={newSituationTextAreaValue => {
            try {
              setGlobalVariableValue({
                key: 'situation',
                value: newSituationTextAreaValue,
              });
            } catch (err) {
              console.error(err);
            }
          }}
          style={[
            styles.TextInput03ad5433,
            { borderColor: theme.colors.divider },
          ]}
          placeholder={"What's the context?"}
          multiline={true}
          numberOfLines={4}
          defaultValue={Constants['situation']}
        />
        {/* Location */}
        <Text style={[styles.Textd02b5e04, { color: theme.colors.strong }]}>
          {'Location'}
        </Text>
        {/* Location text area */}
        <TextInput
          onChangeText={newLocationTextAreaValue => {
            try {
              setGlobalVariableValue({
                key: 'location',
                value: newLocationTextAreaValue,
              });
            } catch (err) {
              console.error(err);
            }
          }}
          style={[
            styles.TextInput03ad5433,
            { borderColor: theme.colors.divider },
          ]}
          placeholder={'Enter a value...'}
          defaultValue={Constants['location']}
        />
        {/* Time */}
        <Text style={[styles.Textd02b5e04, { color: theme.colors.strong }]}>
          {'Time'}
        </Text>
        {/* Time text area */}
        <TextInput
          onChangeText={newTimeTextAreaValue => {
            try {
              setGlobalVariableValue({
                key: 'time',
                value: newTimeTextAreaValue,
              });
            } catch (err) {
              console.error(err);
            }
          }}
          style={[
            styles.TextInput03ad5433,
            { borderColor: theme.colors.divider },
          ]}
          placeholder={'Enter a value...'}
          defaultValue={Constants['time']}
        />
        <View style={styles.Viewb2459fe7}>
          <ButtonSolid
            onPress={() => {
              try {
                navigation.navigate('PracticenoticingParentScreen');
              } catch (err) {
                console.error(err);
              }
            }}
            style={[
              styles.ButtonSolid53168e4d,
              { backgroundColor: theme.colors.primary },
            ]}
            title={'Next'}
          />
        </View>
      </KeyboardAwareScrollView>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  ButtonSolid53168e4d: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
  },
  KeyboardAwareScrollViewc82de0d5Content: {
    marginBottom: 50,
    marginLeft: 20,
    marginRight: 20,
    marginTop: 100,
  },
  Text8acc43bb: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 17,
    textAlign: 'center',
  },
  TextInput03ad5433: {
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRadius: 8,
    borderRightWidth: 1,
    borderTopWidth: 1,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
  },
  Textc3594145: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 28,
    marginTop: 20,
    textAlign: 'center',
  },
  Textd02b5e04: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 17,
    marginTop: 50,
    textAlign: 'center',
  },
  Viewb2459fe7: {
    marginLeft: 100,
    marginRight: 100,
    marginTop: 50,
  },
});

export default withTheme(PracticenoticingSLTScreen);
